import { useEffect, useState } from "react";
import api from "@/lib/api";

// <img> ne peut pas porter d'en-tête Authorization : on récupère la photo en blob.
export default function SouvenirPhoto({ completionId, alt, className }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    api
      .get(`/activities/${completionId}/photo`, { responseType: "blob" })
      .then(({ data }) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setUrl(objectUrl);
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [completionId]);

  if (failed) {
    return (
      <div className={`grid place-items-center bg-[#EDF2F9] text-xs text-[#99A5BB] ${className}`}>
        Photo indisponible
      </div>
    );
  }
  if (!url) {
    return <div className={`animate-pulse bg-[#E3E8F1] ${className}`} />;
  }
  return <img src={url} alt={alt} className={className} data-testid={`souvenir-photo-${completionId}`} />;
}
